import { Link } from "react-router-dom";

const NotFound = () =>{
    return (
        <div className="notfound">
            <h2>404 Error Page</h2>
            <p>404:The page you are looking for does not exist</p>
            <Link to="/">Go back to the Home page</Link>
        </div>
    );
}

export default NotFound;